import React from 'react';

import LookupStatusBadge, { LookupStatus } from '~components/LookupStatusBadge';

import { MandateStatus, MANDATE_STATUS_OPTIONS } from '~direct-debits/models';

// Single-source-of-truth for labels lives in MANDATE_STATUS_OPTIONS; the badge owns
// only the colour mapping, which is UI-specific and not relevant to filter dropdowns.
const statusLabelByStatus: Record<MandateStatus, string> = Object.fromEntries(
  MANDATE_STATUS_OPTIONS.map((option) => [option.id, option.name]),
) as Record<MandateStatus, string>;

// Hex codes mirror Bootstrap 5's themed palette so the visual identity matches what
// reactstrap previously rendered (success / warning / secondary). Hard-coded rather
// than read from CSS vars because these statuses are derived locally — they don't
// participate in the API's `lookup_*` colour scheme used by the other badges.
const statusColourByStatus: Record<MandateStatus, string> = {
  active: '198754',  // bs-success
  pending: 'FFC107', // bs-warning — auto-contrast in LookupStatusBadge picks dark text
  none: '6c757d',    // bs-secondary
};

const toLookupStatus = (status: MandateStatus): LookupStatus => ({
  tag: status,
  name: statusLabelByStatus[status] ?? statusLabelByStatus.none,
  colour: statusColourByStatus[status] ?? statusColourByStatus.none,
});

interface ComponentProps {
  row: { status: MandateStatus };
}

const MandateStatusBadge: React.FC<ComponentProps> = ({ row }) => (
  <LookupStatusBadge
    status={toLookupStatus(row.status)}
    dataCy={`dd-mandate-status-${row.status}`}
    style={{ minWidth: '5.5rem', display: 'inline-block', textAlign: 'center' }}
  />
);

export default MandateStatusBadge;
